import { useState } from "react";
import {
  IconButton,
  Popover,
  Typography,
  Paper,
  List,
  ListItem,
  Box,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export default function FieldInstructions() {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  // Device ID specific instructions
  const instructions = [
    "Swipe up from bottom of your home screen to open the App Drawer.",
    "Scroll though the apps and look for the Settings app, and tap to open it.",
    "Keep scrolling down the list until you find About Phone. Then tap on it.",
    "Scroll down to view the Device ID value that you can use.",
  ];

  // Function to format instructions with bold terms
  const formatInstruction = (text) => {
    const boldTerms = ["App Drawer", "Settings", "About Phone", "Device ID"];

    return text
      .split(/(App Drawer|Settings|About Phone|Device ID)/)
      .map((part, i) => {
        if (boldTerms.includes(part)) {
          return (
            <Box component="span" fontWeight="bold" key={i}>
              {part}
            </Box>
          );
        }
        return part;
      });
  };

  return (
    <>
      <IconButton onClick={handleClick} size="small">
        <HelpOutlineIcon fontSize="small" color="primary" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Paper sx={{ p: 2, maxWidth: 300 }}>
          <Typography variant="subtitle2" gutterBottom>
            How to find Device ID:
          </Typography>
          <List dense>
            {instructions.map((step, index) => (
              <ListItem key={index} sx={{ alignItems: "flex-start" }}>
                <Typography component="div">
                  <Box component="span" fontWeight="bold" mr={0.5}>
                    {index + 1}.
                  </Box>
                  {formatInstruction(step)}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Paper>
      </Popover>
    </>
  );
}
